import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 40, scale: 0.98 }}
    whileInView={{ opacity: 1, y: 0, scale: 1 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const GlowOrbs = () => (
  <div className="pointer-events-none absolute inset-0 overflow-hidden">
    <div className="absolute -top-40 -right-40 h-[500px] w-[500px] rounded-full bg-[#8B5CF6] opacity-20 blur-[160px]" />
    <div className="absolute bottom-0 -left-40 h-[500px] w-[500px] rounded-full bg-[#06B6D4] opacity-[0.15] blur-[160px]" />
  </div>
);
